import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFReport = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.52,18.91H4a2,2,0,0,1-2-2V14.13a2,2,0,0,1,2-2h.52a2,2,0,0,1,2,2v2.78A2,2,0,0,1,4.52,18.91Zm8.74-2V5.09a2,2,0,0,0-2-2h-.52a2,2,0,0,0-2,2V16.91a2,2,0,0,0,2,2h.52A2,2,0,0,0,13.26,16.91Zm6.74,0v-5a2,2,0,0,0-2-2h-.52a2,2,0,0,0-2,2v5a2,2,0,0,0,2,2H18A2,2,0,0,0,20,16.91Z" })
});
export default SvgFReport;
